import * as yup from "yup"
import { Formato } from "../../types"

export function initialValuesFormato(formato?: Formato | undefined) {
  if (formato) {
    return formato
  }
  return {
    nome: "",
  }
}

export function validationSchemaFormato() {
  return yup.object().shape({
    nome: yup.string().required("Campo obbligatorio"),
  })
}
